import axios from 'axios';

// Login-Funktion
export const login = async (drive, key) => {
  const loginData = {
    drive: drive,
    key: key
  };

  try {
    const response = await axios.post('https://api.mitglied.net/login', loginData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.token;
    } else {
      throw new Error('Login fehlgeschlagen');
    }
  } catch (error) {
    console.error('Fehler beim Login:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Mitglieder abrufen
export const getMembers = async (token) => {
  try {
    const response = await axios.get('https://api.mitglied.net/members', {
      headers: {
        'x-api-key': token
      }
    });

    return response.data;
  } catch (error) {
    console.error('Fehler beim Abrufen der Mitglieder:', error.response ? error.response.data : error.message);
    throw error;
  }
};